<template>
  <v-row justify="center" class="blank-widget">
    <change-widget :position="currentPosition" />
  </v-row>
</template>

<script>
import ChangeWidget from '../WidgetDialogs/ChangeWidget'

export default {
  name: 'Blank',
  components: {
    ChangeWidget
  },
  props: {
    widgetData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      blank: {
        val1: 'Hakuma',
        val2: 'matata'
      },
      currentPosition: this.$attrs.position
    }
  },
  methods: {
    //* This updates the dashboard document
    //* The store then gets updated from the firestore snapshot.
    updateStore() {
      // eslint-disable-next-line
      const blank = this.blank
      this.$store.dispatch('dashboard/updateWidgetData', {
        blank
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.blank-widget {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
